import { patientAdd } from "@/api/patient"; // 病人请求
import { provincesList } from "@/api/region"; // 获取区域请求
import { addressAdd, deliveryMethod } from "@/api/address"; // 获取地址
import { validatePhone, validateName } from "@/utils/regexp" // 自定义验证
export default {
    name: 'AddressManage',
    component: {},
    data() {
        return {
            addressVisible: false, // 新增地址模态框
            addressOptions: [], // 配送区域选项
            addressForm: {}, // 收件地址对象
            regionProps: { label: "provincesName", value: "provincesId" }, // 区域选择配置
        }
    },
    created() {
        this.validatePhone = validatePhone;
        this.validateName = validateName;
        this.getProvincesList(); // 请求区域列表
    },
    props: {
        patientForm: Object,
        item: Object,
        addressList: Array,
        i: Number,
        type: String,
        computeWeight: Function,
        getDeliveryPrice: Function,
        getAddressList: Function,
        computeDrugPrice: Function,
        recipeData: Object
    },
    //监听属性 类似于data概念
    computed: {
        formatNumber() {
            let self = this;
            return function (val) {
                // 对计算属性进行传参
                if (val) {
                    return self.$toFixed(val);
                }
            };
        },
    },
    methods: {
        // 请求所有区域列表列表
        async getProvincesList() {
            let { rows, code } = await provincesList();
            if (code == 200) this.listToTree(rows);
        },
        // 链式结构转树形结构
        listToTree(list) {
            // 省份列表
            list.forEach(item => { if (item.type == "0") this.addressOptions.push(item) });
            // 城市列表
            list.forEach(item => {
                if (item.type == "1") {
                    this.addressOptions.forEach(items => {
                        if (item.parentId == items.provincesId) items.children.push(item);
                    });
                }
            });
            // 区/县列表
            list.forEach(item => {
                if (item.type == "2") {
                    this.addressOptions.forEach(items => {
                        items.children.forEach(itemm => {
                            if (item.parentId == itemm.provincesId) itemm.children.push(item);
                        });
                    })
                }
            });
            // 范围列表
            list.forEach(item => {
                if (item.type == "3") {
                    item.children = null
                    this.addressOptions.forEach(items => {
                        items.children.forEach(itemm => {
                            itemm.children.forEach(itemn => {
                                if (item.parentId == itemn.provincesId) itemn.children.push(item);
                            })
                        });
                    })
                }
            });
            // 没有第四级的将第三级children设置为null
            this.addressOptions.forEach(items => {
                items.children.forEach(itemm => {
                    itemm.children.forEach(itemn => {
                        if (itemn.children.length == 0) itemn.children = null;
                    })
                });
            })
        },
        // 切换是否配送
        changeDelivery(val, obj, i) {
            if (val == '0') {
                obj.deliveryPrice = 0;
                obj.orderDelivery = {};
                obj.deliveryOptions = [];
                if (this.type != 'taking') this.computeWeight(obj);
                else this.computeDrugPrice(this.recipeData, this.item);
            } else{
                this.$emit('getAddressList')
                setTimeout(()=>{
                    this.setDeliveryMsg(obj, i);
                },500)
            }
            this.$forceUpdate();
        },
        // 设置配送信息默认值
        setDeliveryMsg(obj, i) {
            if (this.addressList.length > 0) {
                let {
                    cityName,
                    cityId,
                    consigneeName,
                    deliveryMemberId,
                    detailedAddress,
                    phone,
                    price,
                    provinceName,
                    provinceId,
                    regionName,
                    regionId,
                    scopeName,
                    scopeId
                } = this.addressList[0];
                obj.deliveryMemberId = deliveryMemberId;
                obj.orderDelivery = {
                    cityName,
                    cityId,
                    companyName: null,
                    consigneeName,
                    deliveryMemberId,
                    detailedAddress,
                    phone,
                    price,
                    provinceName,
                    provinceId,
                    regionName,
                    regionId,
                    scopeName,
                    scopeId
                };
                this.getDeliveryMethod(obj, i);
                this.$forceUpdate();
            } else this.$message('该患者暂无收货地址，请新建地址！');
        },
        // 切换地址并设置地址实体内容
        changeDeliveryAddress(obj, i) {
            this.$forceUpdate();
            this.addressList.forEach(item => {
                if (item.deliveryMemberId == obj.deliveryMemberId) {
                    let {
                        cityName,
                        cityId,
                        consigneeName,
                        deliveryMemberId,
                        detailedAddress,
                        phone,
                        price,
                        provinceName,
                        provinceId,
                        regionName,
                        regionId,
                        scopeName,
                        scopeId
                    } = item;
                    obj.orderDelivery = {
                        cityName,
                        cityId,
                        companyName: obj.companyName,
                        consigneeName,
                        deliveryMemberId,
                        detailedAddress,
                        phone,
                        price,
                        provinceName,
                        provinceId,
                        regionName,
                        regionId,
                        scopeName,
                        scopeId
                    };
                }
            })
            this.getDeliveryMethod(obj, i);
        },
        // 获取配送方式
        async getDeliveryMethod(obj, i) {
            let { cityId, provinceId, regionId, scopeId } = obj.orderDelivery;
            let { code, data } = await deliveryMethod({ cityId, provinceId, regionId, scopeId });
            if (code == 200) {
                obj.deliveryOptions = JSON.parse(JSON.stringify(this.$otherDeliveryWay));
                data.forEach((kid) => { obj.deliveryOptions.unshift(kid.companyName) });
                obj.orderDelivery.companyName = obj.deliveryOptions[0];
                obj.companyName = obj.deliveryOptions[0];
                this.$forceUpdate();
                if (this.type != 'taking') {
                    this.computeWeight(obj)
                } else {
                    this.computeDrugPrice(this.recipeData, this.item)
                    this.getDeliveryPrice(obj);
                };
            }
        },
        // 切换配送方式
        changeDeliveryWay(val, item, type) {
            this.$forceUpdate();
            if (type != 'taking') this.getDeliveryPrice(val, item, type);
            else {
                item.orderDelivery.companyName = item.companyName;
                if (item.companyName == '顺丰快递' || item.companyName == '同城快递') {
                    let { cityId, regionId, provinceId, scopeId } = item.orderDelivery;
                    let obj = { cityId, provinceId, regionId, scopeId }
                    this.getDeliveryPrice(obj);
                }
            }
        },
        // 设置配送价格
        setDeliveryPrice(obj) {
            obj.orderDelivery.deliveryNumber = obj.deliveryNumber;
            obj.orderDelivery.price = obj.deliveryPrice;
            if (this.type != 'taking') this.computeWeight(obj);
            else this.computeDrugPrice(this.recipeData, this.item)
        },
        // 新增收货地址
        addAddress(index) {
            this.index = index;
            if (!this.patientForm.patientId) {
                let valid = this.validatePatient();
                if (valid == true) {
                    patientAdd(this.patientForm, this.uuid, this.code).then(res => {
                        if (res.code == 200) {
                            this.patientForm.patientId = res.data;
                            this.addressJoin();
                        }
                    })
                } else {
                    this.$message.error("患者信息不完整，请补充完整后再试！");
                    return false;
                };
            } else this.addressJoin();
        },
        // 地址对象拼接
        addressJoin() {
            let { patientId, patientName, phone } = this.patientForm;
            this.addressForm = {
                consigneeName: patientName,
                phone,
                patientId,
                addressRegion: [],
                detailedAddress: null
            }
            this.addressVisible = true;
        },
        // 保存地址新增
        saveAdd() {
            this.$refs['addressForm'].validate((valid) => {
                if (valid) {
                    let params = JSON.parse(JSON.stringify(this.addressForm));
                    params.provinceId = params.addressRegion[0];
                    params.cityId = params.addressRegion[1];
                    params.regionId = params.addressRegion[2];
                    params.scopeId = params.addressRegion[3];
                    addressAdd(params).then(res => {
                        let { code, data } = res;
                        if (code == 200) {
                            this.$message.success("创建收货地址成功！");
                            this.getAddressList();
                            this.item.deliveryMemberId = data;
                            this.item.orderDelivery.deliveryMemberId = data;
                            this.item.orderDelivery.provinceId = params.provinceId
                            this.item.orderDelivery.cityId = params.cityId
                            this.item.orderDelivery.regionId = params.regionId
                            this.item.orderDelivery.scopeId = params.scopeId
                            // let timer = setTimeout(() => {
                            //   // this.getDeliveryMethod(this.item, i);

                            //   clearTimeout(timer);
                            // }, 300);
                            this.changeDeliveryAddress(this.item, 0)
                            this.addressVisible = false;

                        }
                        this.$refs['addressForm'].resetFields();
                    })
                } else return false;
            })
        },
    }
}